const $inject = [];

const lbToggleCtrl = function () {
  let vm = this;

  vm.toggle = toggle;

  function toggle() {
    vm.isActive = !vm.isActive;
    vm.onChange({isActive: vm.isActive});
  }
};

lbToggleCtrl.$inject = $inject;

export default lbToggleCtrl;



// WEBPACK FOOTER //
// ./src/components/lbToggle/lbToggleCtrl.js